import { Provider } from '@angular/core';
import { provideAnimations, provideNoopAnimations } from '@angular/platform-browser/animations';

export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/** True when the OS or browser requests reduced motion. */
export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia(REDUCED_MOTION_QUERY).matches;
}

/** `behavior` for scrollIntoView/scrollTo: smooth unless reduced motion is on. */
export function scrollBehavior(): ScrollBehavior {
  return prefersReducedMotion() ? 'auto' : 'smooth';
}

/**
 * Angular animations, or the no-op engine when reduced motion is on. Read once
 * at bootstrap; triggers still run their callbacks, just without motion.
 */
export function provideMotionAwareAnimations(): Provider[] {
  return prefersReducedMotion() ? provideNoopAnimations() : provideAnimations();
}
